import React from 'react';

import {
  Route,
  Switch
} from 'react-router-dom';

import Index from './components/Index';
import Error from './components/Error';
import Invalid from './components/Invalid';
import ProductDisplayPage from './components/ProductDisplayPage';
import Prequalification from './components/prequalification/Prequalification';
import PdpBanner from './components/pdp/PdpBanner';
import CheckoutDisplay from './components/CheckoutDisplay';
import CartBanner from './components/cart-promo/CartBanner';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faPlus,
} from '@fortawesome/free-solid-svg-icons';

import {
  faCheckCircle,
  faInfoCircle,
  faQuestionCircle,
  faTimes,
  faSpinnerThird,
  faLockAlt
} from '@fortawesome/pro-light-svg-icons';

// Add icons to FA library for global usage
library.add(
  faCheck,
  faCheckCircle,
  faInfoCircle,
  faPlus,
  faQuestionCircle,
  faTimes,
  faSpinnerThird,
  faLockAlt
);

export default function App() {
  return (
    <div className="App is-clipped">
      <Switch>
        <Route exact path="/" component={Index} />
        <Route exact path="/pdp/:public_key/:type/:charges" component={ProductDisplayPage} />
        <Route path="/checkout/:public_key/:charges" component={CheckoutDisplay} />
        <Route path="/pdp/:public_key/:charges" component={PdpBanner} />
        <Route path="/pdp/:public_key/:desktop/:mobile/:charges" component={PdpBanner} />
        <Route path="/cart-promo/:public_key/:desktop/:mobile/:charges" component={CartBanner} />
        <Route path="/prequal" component={Prequalification} />
      </Switch>
    </div>
  )
}
